import { render, staticRenderFns } from "./AttachmentDraft.vue?vue&type=template&id=54341e9d"
import script from "./AttachmentDraft.vue?vue&type=script&lang=js"
export * from "./AttachmentDraft.vue?vue&type=script&lang=js"
import style0 from "./AttachmentDraft.vue?vue&type=style&index=0&id=54341e9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports